import { PropsWithChildren } from 'react';
import OurLazyLoad, { LazyProp } from './OurLazyLoad';

const LazyLoad = <T = PropsWithChildren>(load: LazyProp<T>) => (props: T) => <OurLazyLoad<T> load={load} {...props} />;

export default LazyLoad;